module.exports = __webpack_public_path__ + "img/floor-plan-sample.8c5e6a23.png";